import {browserHistory} from "react-router"
import shop from "../../shop/shop"
import {translate} from "translate"

const checkCartSize = () => {
  if ( shop.cart.size === 0 ) {
    browserHistory.replace( "/checkout" )
    shop.toast( `${translate( "message.empty_cart" )}` )
    return false
  }
  return true
}

const checkMinCartValue = (value) => {
  if ( !value ) {
    value = shop.session.value && shop.session.value.extras.min_order_value || 150
  }

  console.log( `checking min cart value:`, value )

  if ( shop.cart.sum < value ) {
    browserHistory.replace( "/checkout" )
    shop.toast( `${translate( "message.min_order_value", { value } )}` )
    return false
  }
  return true
}

export {checkCartSize, checkMinCartValue}



// WEBPACK FOOTER //
// ./src/pages/checkout/check.js